// extracted by mini-css-extract-plugin
export default {"button":"style_button__Bo9hp","greenBtn":"style_greenBtn__j5owe","inputLabel":"style_inputLabel__Se8rM"};